export default __webpack_public_path__ + "static/media/edge_icon5.b389f169.svg";